module.exports = __webpack_public_path__ + "img/RCloudServices.48899775.png";